import React from 'react';
import styled, {keyframes} from 'styled-components';
import AlertInfoIcon from "../../../assets/images/icon/AlertInfoIcon";
import WarnIcon from "../../../assets/images/icon/WarnIcon";
import DangerIcon from "../../../assets/images/icon/DangerIcon";
import SuccessIcon from "../../../assets/images/icon/SuccessIcon";
import {useRecoilState, useSetRecoilState} from "recoil";
import {Alert} from "../../../state";

const fadeIn = keyframes`
  from {
    top: -16px;
    display: block!important;  
    opacity: 0; /* 투명도를 0으로 설정하여 처음에는 보이지 않도록 합니다. */
  }

  to {
    top: 0;
    opacity: 0.85; /* 투명도를 1로 설정하여 완전히 보이도록 합니다. */
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    display: block;
  }

  to {
    opacity: 0;
    display: none!important;
  }
`;
const AlertMessage = (props) => {

    const [alert, setAlert] = useRecoilState(Alert)

    const returnAlertIcon = (type) => {
        switch (type) {
            case "info":{
                return <AlertInfoIcon/>
            }
            case "warn":{
                return <WarnIcon/>
            }
            case "danger":{
                return <DangerIcon/>
            }
            case "success":{
                return <SuccessIcon/>
            }
        }
    }

    const returnAlertBackground = (type) => {
        switch (type) {
            case "blue":{
                return {
                    background:"rgba(227, 242, 255, 1)",
                    border:"rgba(19, 84, 212, 1)"

                }
            }
            case "red":{
                return {
                    background: "rgba(255, 228, 229, 1)",
                    border: "rgba(235, 87, 87, 1)"
                }
            }
            case "green":{
                return {
                    background: "rgba(226, 255, 241, 1)",
                    border: "rgba(18, 166, 94, 1)"
                }
            }
            case "yellow":{
                return {
                    background: "rgba(255, 248, 225, 1)",
                    border:"rgba(252, 201, 34, 1)"
                }
            }
        }
    }

return(
  <Container isActive={alert.isActive}>
      <Content
        style={{
            background:returnAlertBackground(alert.color)?.background,
            borderColor:returnAlertBackground(alert.color)?.border,
        }}
      >
          <Icon>
              {returnAlertIcon(alert.type)}
          </Icon>
          <Text>
              <h2>{alert.text || "Congratulations!"}</h2>
              <p>{alert.desc || ""}</p>
          </Text>
          <Icon
              onClick={()=>{
                  setAlert({
                      ...alert,
                      isActive: false
                  })
              }}
          >
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect y="0.949219" width="24" height="24" rx="12" fill="white" fill-opacity="0.6"/>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M18.7071 6.24211C19.0976 6.63264 19.0976 7.2658 18.7071 7.65633L6.70711 19.6563C6.31658 20.0469 5.68342 20.0469 5.29289 19.6563C4.90237 19.2658 4.90237 18.6326 5.29289 18.2421L17.2929 6.24211C17.6834 5.85159 18.3166 5.85159 18.7071 6.24211Z"
                        fill="#333333"/>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M5.29289 6.24211C5.68342 5.85159 6.31658 5.85159 6.70711 6.24211L18.7071 18.2421C19.0976 18.6326 19.0976 19.2658 18.7071 19.6563C18.3166 20.0469 17.6834 20.0469 17.2929 19.6563L5.29289 7.65633C4.90237 7.2658 4.90237 6.63264 5.29289 6.24211Z"
                        fill="#333333"/>
              </svg>
          </Icon>
      </Content>
  </Container>
)

}
export default AlertMessage;

const Container = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>`
    position: fixed;
    left: 50%;
    transform: translate(-50%, 100%);
    z-index: 999999999;
    max-width: 560px;
    width: 100%;
    display: block;
    padding: 0px 20px;
    animation: ${props => props.isActive == true ? fadeIn : fadeOut} 0.2s ease-in-out; /* fadeIn 또는 fadeOut을 조건에 따라 선택 */
`;

const Content = styled.div`
    opacity: 0.9;
    background: rgba(226, 255, 241, 1);
    border: 2px solid rgba(18, 166, 94, 0.62);
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 10px;
`
const Icon = styled.div`
    cursor: pointer;
`
const Text = styled.div`
    flex: 1;
    padding: 0 13px;
    h2{
        font-family: "Europa-Bold";
        font-size: 18px;
        font-weight: 700;
        line-height: 24px;
        text-align: left;
        color: #333;
    }
    p{
        font-family: "Source Serif 4", sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
        text-align: left;
        color: rgba(68, 67, 67, 1);
    }
`